import { Injectable } from '@angular/core';
import { JsxgraphStatic } from './jsxgraph.model';

/**
 * Service that provides the JSXGraph library instance.
 * Uses Lazy loading - fist call loads library, next call loads same instance (improves loading time)
 */
@Injectable()
export class JsxgraphService {
  private jsxgraphInstance: JsxgraphStatic | null = null;

  get instance() {
    return this.jsxgraphInstance;
  }

  async loadJsxgraph(): Promise<JsxgraphStatic> {
    if (this.jsxgraphInstance) {
      return this.jsxgraphInstance;
    }

    this.jsxgraphInstance = (await import('jsxgraph')) as JsxgraphStatic;
    return this.jsxgraphInstance;
  }
}
